import { httpApi } from '@app/api/http.api';

export interface MailerSettingData {
  host: string;
  port: number;
  username: string;
  password: string;
}

export interface GeneralConfig {
  instagramUrl: string;
  faqUrl: string;
  faq: {
    [key: string]: string;
  };
}

export interface Inspiration {
  key: string;
  url?: string;
}

export const getMailerConfig = (): Promise<MailerSettingData> =>
  httpApi.get<MailerSettingData>('/app-settings/mailer').then(({ data }) => data);

export const updateMailerConfig = (data: MailerSettingData): Promise<undefined> =>
  httpApi.put<undefined>(`/app-settings/mailer`, { ...data }).then(({ data }) => data);

export const getGeneralConfig = (): Promise<GeneralConfig> =>
  httpApi.get<GeneralConfig>('/app-settings/general').then(({ data }) => data);

export const updateGeneralConfig = (data: GeneralConfig): Promise<undefined> =>
  httpApi.put<undefined>(`/app-settings/general`, { ...data }).then(({ data }) => data);
